/**
 * What a screen shows while it is waiting on the one call in this app that reaches a model.
 *
 * Everything else here is local-first and answers in a frame, so waiting is not a state the
 * rest of the app has to describe. Looking up a food the catalog has never heard of is the
 * exception, and it can take several seconds — long enough that a screen which says nothing
 * reads as a screen that did not hear the tap, which is how one shopping trip becomes two of
 * everything on the list.
 *
 * One component rather than one per screen, because two places describing the same wait in two
 * ways is the thing worth avoiding: adding reaches this from quick-add and from the groceries
 * list, and it is the same wait for the same reason.
 */

interface Props {
  /** The food being looked up, named so the wait is visibly about what was just typed. */
  name: string;
}

export function LookingUp({ name }: Props) {
  return (
    <p class="looking" role="status">
      <span class="spinner" aria-hidden="true" />
      <span>Looking up “{name}” …</span>
    </p>
  );
}
